import { Modal, OfficeButton, toast } from 'components';
import { useNavigate, useSearch } from 'react-location';
import { LocationGenerics } from 'router/location';
import { useProduct } from 'pages/products/hooks/use-products';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useUpdateProductCategoriesAndTag } from './hooks/use-update-category-and-tag';
import UpdateCategoryAndTagForm from './forms/update-category-and-tag-form';
import { ProductStatus } from '_graphql/__generated__/globalTypes';

type Props = {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
};

const UpdateProductCategoryAndTag = ({ open, setOpen }: Props) => {
  const navigate = useNavigate<LocationGenerics>();
  const seacrhParams = useSearch<LocationGenerics>();
  const { loading: updating, updateProductCategoryAndTag } =
    useUpdateProductCategoriesAndTag();

  const { product, loading } = useProduct({
    variables: {
      filter: seacrhParams?.id
        ? {
          id: {
            eq: seacrhParams?.id,
          },
        }
        : undefined,
    },
  });

  const { ...form } = useFormik({
    initialValues: {
      categories: [] as any,
      tags: [] as any,
    },
    validationSchema: Yup.object().shape({
      categories: Yup.array()
        .min(1, 'Choose at least one category')
        .required('Category is required'),
    }),
    onSubmit: async (values) => {
      await updateProductCategoryAndTag({
        variables: {
          input: {
            product_id: product?.id || '',
            categories: values.categories,
            tags: values.tags,
            personnel:"Supplier",
            published:false,
            reason:"N/A",
            status:ProductStatus.PENDING,
            verified:false
          },
        },
      })
        .then(({ data }) => {
          if (data?.updateProductCategoryAndTags) {
            toast('Product Category Updated Successfully', 'success');
            form.resetForm();
            navigate({
              to: `/products/${product?.id}`,
            });
          } else {
            toast('Something went wrong', 'error');
          }
        })
        .catch((err) => {
          toast(err.message, 'error');
        });
    },
  });

  return (
    <Modal
      open={open}
      setOpen={() => {
        setOpen(false);
        navigate({
          search: (old) => ({
            ...old,
            modal: undefined,
            id: undefined,
          }),
        });
      }}
      loading={loading}
      title='Update Product'
      description='Update Product Category And Distribution'
      renderActions={() => (
        <div className='md:ml-10'>
          <OfficeButton
            onClick={form.handleSubmit}
            size='lg'
            width='auto'
            disabled={updating}
            type='submit'>
            {updating ? 'Updating...' : 'Update'}
          </OfficeButton>
        </div>
      )}>
      <UpdateCategoryAndTagForm
        form={form}
        product={product}
        loading={loading}
      />
    </Modal>
  );
};

export default UpdateProductCategoryAndTag;
